import { Box, Center, Heading, VStack } from '@chakra-ui/react'
import { InvestorSearchBuilder } from '@src/components/sco/InvestorMatching/InvestorSearchBuilder'
import { InvestorSearchesList } from '@src/components/sco/InvestorMatching/InvestorSearchesList'
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar'

import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider'
import { useCurrentUser } from '@src/hooks/useCurrentUser'
import React from 'react'

export { getServerSideProps } from '@src/lib/server-side-rendering'

export default function Page() {
  const { currentUser } = useCurrentUser()
  const { getBreakpointValue } = useBreakpointContext()

  return (
    <>
      <ScoSiteNavBar />
      <Center minHeight={'90vh'} paddingX={[4, 4, 4, 8]} paddingY={[4, 4, 8, 10, 16]}>
        <VStack align={'center'} gap={getBreakpointValue([6, 6, 8, 8, 10, 10])}>
          <VStack align={'center'} gap={4} justify={'center'} textAlign={'center'}>
            <Heading
              as={'h1'}
              backgroundClip={'text'}
              backgroundImage={'linear-gradient(90deg, #d97258 0%, #9858a3 100%)'}
              color={'transparent'}
              size={['3xl', '4xl', '4xl', '5xl', '5xl']}
            >
              Raise Capital 10x Faster
            </Heading>
            <Heading as={'h2'} color={'mocha'} fontSize={['xl', 'xl', 'xl', '2xl']} fontWeight={'600'}>
              Accelerator your fundraise with investor matching and automated outreach.
            </Heading>
          </VStack>

          {currentUser?.investorSearches?.pagination?.itemCount > 0 && (
            <>
              <Box
                bgColor={'sidebarBackground'}
                borderRadius={'lg'}
                boxShadow={'lg'}
                padding={getBreakpointValue(['4', '4', '6', '6'])}
                width={'full'}
              >
                <InvestorSearchesList
                  excludeEmptyResults={true}
                  hideIfEmpty={true}
                  resultsSimpleGridProps={{ columns: getBreakpointValue([1, 2, 3, 3]), gap: 2 }}
                  investorSearchCardProps={{
                    ctaType: 'open',
                  }}
                />
              </Box>
            </>
          )}

          <InvestorSearchBuilder
            containerBoxProps={{ maxWidth: '920px' }}
            hide={{ companyName: true }}
            labels={{ formTitle: 'Tell us more...' }}
          />
        </VStack>
      </Center>
    </>
  )
}
